app.controller(
    'BioController', ['$scope', '$rootScope', '$state', '$stateParams', 'TranslateService', 'BioService', 'SideBarService', 'HelperService', 'ShareUrlService', 'ExplorerService', '$window', BioController]
);

function BioController($scope, $rootScope, $state, $stateParams, TranslateService, BioService, SideBarService, HelperService, ShareUrlService, ExplorerService, $window) {
    var vm = this;
    vm.ActiveDescription = {};
    vm.ActiveDescriptionId = 0;
    vm.IsCreatingNewDescriptionForBio = false;

    vm.Bio = {
        DescriptionPositionList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
    };
    vm.ActiveDescriptionVm =
        {
            DescriptionNewPositionText: '1'
        };
    
    $scope.edit = {};
    $scope.item = {};

    $scope.contentTranslate = null;

    $scope.item.disaplayName = $scope.item.name || ($scope.item.firstName || $scope.item.lastName);


    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    

    

    if ($stateParams.id) {
        vm.ParamBioId = $stateParams.id;
    }
    else {
        vm.ParamBioId = $rootScope.DefaultGlobalZoneId;
    }

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = vm.ParamZoneId;

    initController();

    function initController() {
        TranslateService.use($rootScope.LangForInterface);        
        loadBio(vm.ParamBioId, $scope.CurrentLang, "", $stateParams.index, $stateParams.sortKey, $stateParams.reverse);        
    }

    function loadBio(bioId, lang, lang2, index, sortKey, reverse) {
        BioService.GetBio(bioId, lang, lang2, index, sortKey, reverse)
            .then(function (bio) {

                vm.Bio = bio;
                if (vm.Bio.DescriptionList.length > 0) {
                    if ($stateParams.descpos) {
                        if ($stateParams.descpos > vm.Bio.DescriptionList.length) {
                            $stateParams.descpos = vm.Bio.DescriptionList.length;
                        }
                        vm.ActiveDescriptionId = $stateParams.descpos-1;
                    }
                    else {
                        vm.ActiveDescriptionId = 0;
                    }                                        
                    vm.ActiveDescription = vm.Bio.DescriptionList[vm.ActiveDescriptionId];
                    vm.GetDescriptionVm();
                }
                $rootScope.Clients = bio.ClientList;
                $rootScope.Comments = bio.CommentList;
                $rootScope.SideBar = bio.SideBar;

                $rootScope.CurrentObjectId = bioId;
                $rootScope.CurrentPageType = $rootScope.EnumLinkType.Bio;
                $rootScope.CurrentObjectStatus = bio.CurrentBioStatus;
                $rootScope.SideBar.CurrentObjectStatus = bio.CurrentBioStatus;
                $rootScope.SideBar.StatusList = $rootScope.StatusList4WorkflowObjectSt;
                $rootScope.SideBar.MesNotes = vm.Bio.Bio.MyNotes;
                $rootScope.SideBar.bioVmProfessionTranslation = bio.ProfessionTranslation;

                vm.GetAssociatedPlacesOnSideBar();
                vm.GetAssociatedZonesOnSideBar();
                vm.GetAssociatedFilesOnSideBar();
                $rootScope.getJobList();
                
                vm.StatusList4WorkflowDescriptionObj = angular.copy($rootScope.StatusList4WorkflowDescriptionSt);

                //$scope.ChangeZoneById(vm.ParamZoneId);
            });
    }

    vm.UpdateBio = function () {

        BioService.UpdateBio(vm.Bio.Bio)
            .then(function (data) {


            });
    }

    vm.UpdateDescriptionVm = function () {
        if (!vm.IsCreatingNewDescriptionForBio) {
            HelperService.UpdateDescriptionVm(vm.ActiveDescriptionVm, $rootScope.EnumLinkType.Bio)
            .then(
               function success(data) {
                   //recharge la page si la position du desc est modifié
                   if (vm.ActiveDescriptionVm.DescriptionCurrentPositionText != vm.ActiveDescriptionVm.DescriptionNewPositionText) {
                       window.location.reload();
                   }
               },
               function error(data) { });
        }
        else {
            vm.CreateNewDescriptionForBio();            
        }
    }

    $rootScope.refreshHistory = function refreshHistory() {
        var lastelement = $rootScope.SideBar.HistoryList == null ? null : $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "Bio", (lastelement == null ? 0 : lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                  function success(data) {
                      $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);

                  },
                function error(data) {
                });
    };

    $rootScope.AddComment = function AddComment(CurrentObjectId) {
        promiseAddComment = SideBarService.AddComment(vm.Bio.SideBar.CommentEdit, vm.Bio.Bio.BioId, $stateParams.lang, $rootScope.EnumLinkType.Bio);

        promiseAddComment
            .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;                    
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                }
            );
    };

    $rootScope.SaveDiffuseur = function SaveDiffuseur() {
        SideBarService.SaveDiffuseur($rootScope.Clients, vm.Bio.Bio.BioId, $stateParams.lang, $rootScope.EnumLinkType.Bio);
    };

    vm.PrepareCreateNewDescriptionForBio = function () {
        //add new desc local
        vm.IsCreatingNewDescriptionForBio = true;
        var newDescLocal = {};
        newDescLocal.DescriptionId = 0;

        vm.ActiveDescriptionVm.Description = {};
        vm.ActiveDescriptionVm.Description.DescriptionId = 0;
        vm.ActiveDescriptionVm.Description.DescriptionTitle = '';
        vm.ActiveDescriptionVm.Description.Stick = '';
        vm.ActiveDescriptionVm.Description.Resume = '';
        vm.ActiveDescriptionVm.Description.Description = '';
        vm.ActiveDescriptionVm.DescriptionStatus = '';
        vm.ActiveDescriptionVm.Clients = [];
        vm.ActiveDescriptionVm.QualificationList = [];
        var lastIndex = vm.Bio.DescriptionList.push(newDescLocal) - 1;
        vm.ActiveDescriptionId = lastIndex;
    }


    vm.CreateNewDescriptionForBio = function () {
        //prepare data supplement
        var descForCreation = {};
        descForCreation.ObjectId = vm.Bio.Bio.BioId;
        descForCreation.CurrentLang = $scope.CurrentLang;
        descForCreation.LinkTypeId = $rootScope.EnumLinkType.Bio;
        descForCreation.DescriptionTranslation = vm.ActiveDescriptionVm.Description;
        descForCreation.DescriptionStatus = vm.ActiveDescriptionVm.DescriptionStatus;

        BioService.CreateNewDescriptionForBio(descForCreation)
        .then(
                function success(data) {
                    vm.IsCreatingNewDescriptionForBio = false;
                    vm.Bio.DescriptionList[vm.ActiveDescriptionId] = $rootScope.returnNewDesc;
                    $state.go('app.consultation.bio', { id: vm.Bio.Bio.BioId, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: vm.Bio.DescriptionList.length });
                },
                function error(data) { });
    }

    vm.OpenInOtherLang = function (lang) {
        $window.location.href = $rootScope.interfaceSubFolder + '/#!/consultation/bio?id=' + vm.Bio.Bio.BioId + "&lang=" + lang + "&index=" + $stateParams.index + "&sortKey=" + $stateParams.sortKey + "&reverse=" + $stateParams.reverse + "&z=" + $stateParams.z;
    }

    vm.GetDescriptionVm = function () {
        HelperService.GetDescriptionVmWithSort(vm.Bio.DescriptionList[vm.ActiveDescriptionId].DescriptionId, vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, 0, $scope.CurrentLang)
            .then(function (desc) {
                vm.ActiveDescriptionVm = desc;
            });
    }

    vm.GetAssociatedPlacesOnSideBar = function () {
        HelperService.GetAssociatedPlacesOnSideBar(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang, true)
            .then(function (data) {
                $rootScope.AssociatedPlaces = data;
            });
    }

    $rootScope.SaveAssociatedPlaces = function SaveAssociatedPlaces() {
        promiseAddComment = SideBarService.SaveAssociatedPlaces(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang, $rootScope.AssociatedPlaces);
    };

    vm.GetAssociatedZonesOnSideBar = function () {
        HelperService.GetAssociatedZonesOnSideBar(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang)
            .then(function (data) {
                $rootScope.AssociatedZones = data;
                });
    }

    $rootScope.SaveAssociatedZones = function SaveAssociatedZones() {
        promiseAddComment = SideBarService.SaveAssociatedZones(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang, $rootScope.AssociatedZones);
    };

    $rootScope.SaveQualificationAssociees = function () {
        HelperService.SaveQualificationAssociees(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang, $rootScope.SideBar.QualificationList);
    }

    $rootScope.SaveJobAssocie = function () {
        HelperService.SaveJobAssocie(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $rootScope.SideBar.bioVmProfessionTranslation);
    }

    vm.GetAssociatedFilesOnSideBar = function () {
        HelperService.GetAssociatedFilesOnSideBar(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang)
            .then(function (data) {
                $rootScope.AssociatedFiles = data;
            });
    }

    $rootScope.DownloadAssociatedFile = function (name, $event) {
        $event.stopPropagation();        
        var path = name;
        //path = 'test';
        //if ($stateParams.path !== undefined)
        //    path = $stateParams.path + "/" + name;
        ExplorerService.DownloadAssociatedFile(path, "application/pdf")
            .then(function (response) {
                $scope.selectedItem = null;
            }, function (response) {
                if (response.status > 0) {
                    $scope.errorMsg = response.status + ': ' + response.data;
                }
            }, function (evt) {
                console.log(evt);
                $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                console.log($scope.progress);
            }
            );

    };

    $scope.view = function (name, $event) {
        $event.stopPropagation();
        var path = name;
        if ($stateParams.path !== undefined)
            path = $stateParams.path + "/" + name;
        ExplorerService.Download(path, "application/pdf");
    };

    vm.PreviousDesc = function () {
        if (vm.Bio.DescriptionList.length > 0 && vm.ActiveDescriptionId > 0) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId - 1;            
            $state.transitionTo('app.consultation.bio', { id: vm.Bio.Bio.BioId, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: vm.ActiveDescriptionId + 1 }, { notify: false });
            vm.GetDescriptionVm();
        }
    }

    vm.NextDesc = function () {
        if (vm.Bio.DescriptionList.length > 0 && vm.ActiveDescriptionId < vm.Bio.DescriptionList.length - 1) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId + 1;
            $state.transitionTo('app.consultation.bio', { id: vm.Bio.Bio.BioId, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: vm.ActiveDescriptionId + 1 }, { notify: false });
            vm.GetDescriptionVm();
        }
    }

    // SideBar method
    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {
        SideBarService.UpdateObjectStatus(status, objectId, $scope.CurrentLang, $rootScope.EnumLinkType.Bio);
    };

    vm.UpdateDescriptionStatus = function () {
        if (vm.ActiveDescriptionVm.Description != undefined && vm.ActiveDescriptionVm.Description.DescriptionId != 0) {
            HelperService.UpdateDescriptionStatus(vm.ActiveDescriptionVm.Description.DescriptionId, $scope.CurrentLang, vm.ActiveDescriptionVm.DescriptionStatus);
        }
    }

    vm.UpdateDescriptionPosition = function () {
        if (vm.ActiveDescriptionVm.Description != undefined && vm.ActiveDescriptionVm.Description.DescriptionId != 0) {
            HelperService.UpdateDescriptionPosition(vm.Bio.Bio.BioId, vm.ActiveDescriptionVm.Description.DescriptionId, vm.ActiveDescriptionVm.DescriptionCurrentPositionText, vm.ActiveDescriptionVm.DescriptionNewPositionText, $rootScope.EnumLinkType.Bio);
        }
    }

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareFicheComplete();
    }    

    $rootScope.shareFicheComplete = function () {
        ShareUrlService.GenerateSharedUrl($stateParams.id, $rootScope.EnumLinkType.Bio, $rootScope.LangForWork)
            .then(function (data) {
                $rootScope.ShareUrlObj = data.data;
            },
            function (data) {
            }
        );
    }    
}